import { Injectable } from '@angular/core';
import { 
  HttpInterceptor, 
  HttpRequest, 
  HttpHandler, 
  HttpEvent, 
  HttpErrorResponse 
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppConfig } from '../config/app.config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly loginUrl = `${AppConfig.apiBaseUrl}api/auth/login`;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip adding token for login endpoint
    if (req.url === this.loginUrl) {
      return next.handle(req);
    }

    // Get token from AuthService
    const token = this.authService.getToken();

    // Clone the request and add the authorization header if token exists and not expired
    let clonedRequest = req;
    if (token && !this.authService.isTokenExpired()) {
      clonedRequest = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    // Handle the request and catch 401/403 errors
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized - token invalid or missing
        if (error.status === 401) {
          // Clear auth state and redirect to login
          this.authService.logout();
          return throwError(() => error);
        }

        // Handle 403 Forbidden - token valid but insufficient permissions
        if (error.status === 403) {
          // Don't logout, just show error
          console.warn('Access forbidden: Insufficient permissions');
          return throwError(() => error);
        }

        // Re-throw other errors
        return throwError(() => error);
      })
    );
  }
}
